import { createLocale } from '../../utils.js';

import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';

export default {
  en: createLocale(en, 'materials'),
  uk: createLocale(uk, 'materials'),
  pl: createLocale(pl, 'materials'),
  ru: createLocale(ru, 'materials'),
  es: createLocale(es, 'materials'),
  uz: createLocale(uz, 'materials'),
  hi: createLocale(hi, 'materials'),
};
